import styled from 'styled-components';

export const Table = styled.table<{
  backgroundColor?: string;
  boxShadow?: string;
}>`
  border-radius: 5px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.palette.background.paper};
  box-sizing: border-box;
  padding: 0 20px;
  border-collapse: collapse;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  box-shadow: ${({ boxShadow }) => boxShadow ?? 'none'};

  tbody {
    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
      display: block;
    }
  }

  thead {
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    box-sizing: border-box;
    height: 50px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      display: none;
    }
  }

  td {
    &:last-child {
      padding-right: 40px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        padding-right: 20px;
      }
    }
  }

  tr {
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    box-sizing: border-box;
    height: 50px;

    background-color: ${({ backgroundColor, theme }) =>
      backgroundColor ?? theme.palette.background.paper};
    transition: background-color 0.2s;

    &:hover {
      background-color: ${({ theme }) => theme.palette.action.hover};

      .blue-hover {
        color: ${({ theme }) => theme.palette.info.main};
      }

      .hover-only {
        opacity: 1;
      }
    }

    &:last-child {
      border-bottom: 0;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      display: block;
      padding: 20px;
      height: 100%;
      position: relative;
    }
  }

  thead {
    text-align: left;
    tr {
      &:hover {
        background-color: ${({ theme }) => theme.palette.background.paper};
      }
    }
  }

  td,
  th {
    padding: 0 20px;
    box-sizing: border-box;

    &.small {
      font-size: 14px;
      color: ${({ theme }) => theme.palette.common.black};
    }

    &.small-light {
      font-size: 14px;
      color: ${({ theme }) => theme.palette.text.secondary};
    }

    &.date {
      font-size: 14px;
      color: ${({ theme }) => theme.palette.text.secondary};
      text-align: left;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 12px;
        text-align: right;
      }
    }

    &.status {
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;

        ${({ theme }) => theme.breakpoints.down('sm')} {
          display: block;
        }
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        position: absolute;
        top: calc(50% - 4px);
        left: 0;
      }
    }

    &.default {
      font-size: 16px;
    }

    &.blue-hover {
      font-size: 16px;
    }

    &.hover-only {
      opacity: 0;
      transition: opacity 0.2s;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      padding: 0;
    }

    ${({ theme }) => theme.breakpoints.up('sm')} {
      max-width: 220px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    border-radius: 0;
  }
`;

export const TableTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;

  h2 {
    font-size: 15px;
    margin: 0;
    margin-left: 10px;
    padding: 0;
    font-weight: bold;
  }
`;

export const ArrowContainer = styled.div<{ inverted: boolean }>`
  margin-left: 5px;
  width: 20px;
  height: 20px;
  display: inline-block;
  text-align: center;
  transform: rotate(${(p) => (p.inverted ? '180deg' : '0')});
`;

export const NavContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 5px;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`;

export const NavArrowContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  border-radius: 7px;
  overflow: hidden;
`;

export const NavArrow = styled.div<{ backgroundColor?: string }>`
  width: 20px;
  height: 20px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.palette.background.paper};
  padding: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.default};
  }
`;

export const PageNumber = styled.p`
  font-weight: initial;
  margin: 0;
  padding: 0 10px;
`;
